if ($('.product-slider .item').length > 4) { // no slider unless necessary
  $('.product-slider').imagesLoaded(function(){
    let $slider = $('.product-slider .items');
    $slider.on('init', function(){
      var trackHeight = $slider.find('.slick-track').outerHeight();
      $slider.find('.slick-slide').css('height', trackHeight);
    });
    $slider.slick({
      arrows: true,
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: sliderArrowPrev,
      nextArrow: sliderArrowNext,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: app.breakpoints.mdMax,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: app.breakpoints.xsMax,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}

if ($('.media-slider .item').length > 1) {
  let $slider = $('.media-slider');
  let $selectedThumb = $('.media-thumbs .thumb').first();
  let preselected = $('.media-thumbs').data('preselected');
  if (preselected) {
    $selectedThumb = $('.media-thumbs [data-for=' + preselected + ']'); console.log($selectedThumb);
  }
  $slider.on('init', function(event, slick, currentSlide, nextSlide){
    $selectedThumb.addClass('active');
    // var trackHeight = $slider.find('.slick-track').outerHeight();
    // $slider.find('.slick-slide').css('height', trackHeight);
  });
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.media-thumbs .thumb').removeClass('active');
    $('.media-thumbs .thumb').eq(nextSlide).addClass('active');
  });
  $slider.slick({
	initialSlide: $selectedThumb.index(),
	arrows: true,
	dots: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	prevArrow: sliderArrowPrev,
	nextArrow: sliderArrowNext,
	fade: true,
	adaptiveHeight: true,
	responsive: [
	  {
		breakpoint: app.breakpoints.mdMax,
		settings: {
		  fade: false
		}
	  }
	]
  });
  $('.media-thumbs a').on('click', function(e){
	e.preventDefault();
	// show the slider again if it was hidden by a bespoke variant image
	if ($('.is-variant-image').length) {
	  $('.is-variant-image').remove();
	  $('.media-slider').show();
	}
	$('.media-thumbs a').removeClass('active');
	$(this).addClass('active');
	$slider.slick('slickGoTo',$(this).index());
  });
} else {
  $('.media-slider').addClass('slick-initialized');
}

if ($('.photo-gallery .item').length > 1) { // no slider unless necessary
  $('.photo-gallery').imagesLoaded(function(){
    let $slider = $('.photo-gallery .items');
    $slider.slick({
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      prevArrow: sliderArrowPrev,
      nextArrow: sliderArrowNext,
      centerMode: true
    });
    $('.photo-gallery-thumbnails .modal-trigger').on('click', function(e){
      $slider.slick('slickGoTo', $(this).data('index'));
    });
  });
}

if ($('.carousel .item').length > 1) { // no slider unless necessary
	$('.carousel').imagesLoaded(function(){
	  let $slider = $('.carousel .items');
	  $slider.slick({
		arrows: true,
		dots: true,
		prevArrow: sliderArrowPrev,
		nextArrow: sliderArrowNext
	  });
	});
  }

// inner/outer values are from inner to outer starting from the center
if ($('.coverflow').length) {
  var stackSize = $('.coverflow').data('size');
  var startingIndex = Math.floor(stackSize / 2);
  var $dots = $('.coverflow-dots i');
  var $cards = $('.coverflow .card');

  // use the same slider markup as slick
  $('.coverflow').closest('.card-stack').prepend(sliderArrowPrev);
  $('.coverflow').closest('.card-stack').append(sliderArrowNext);
  var $prevArrow = $('.card-stack .slick-prev');
  var $nextArrow = $('.card-stack .slick-next');

  var getCoverflow = function($el){
    return $el.closest('.card-stack').find('.coverflow');
  };

  $('.coverflow').coverflow({
    enableWheel: false,
    density: 1.5,
    innerAngle: 0,
    innerScale: .88,
    outerAngle: 0,
    outerScale: .59,
    index: startingIndex,
    change: function(event, cover, index){
      $dots.removeClass('active');
      $dots.eq(index).addClass('active');
      if (index - 1 < 0){
        $prevArrow.prop('disabled',true);
      }else{
        $prevArrow.prop('disabled',false);
      }
      if (index + 1 >= stackSize){
        $nextArrow.prop('disabled',true);
      }else{
        $nextArrow.prop('disabled',false);
      }
      $cards.attr('tabindex', -1);
      $cards.eq(index).attr('tabindex', 0);
    }
  });
  // set active dot
  $dots.eq(startingIndex).addClass('active');
  // enable tabbing for active card
  $cards.eq(startingIndex).attr('tabindex', 0);
  // prev / next
  $prevArrow.on('click', function(e){
    e.preventDefault();
    var $cf = getCoverflow($(this));
    let currentIndex = $cf.coverflow('index');
    let nextIndex = currentIndex - 1;
    if (nextIndex > -1) {
      $cf.coverflow('index', nextIndex);
    }
  });
  $nextArrow.on('click', function(e){
    e.preventDefault();
    var $cf = getCoverflow($(this));
    let currentIndex = $cf.coverflow('index');
    let nextIndex = currentIndex + 1;
    if (nextIndex < stackSize) {
      $cf.coverflow('index', nextIndex);
    }
  });
}

/*
Saves Club Videos
*/
if ($('#saves-club-videos .item').length > 3) { // no slider unless necessary
  $('#saves-club-videos').imagesLoaded(function(){
    let $slider = $('#saves-club-videos .items');
    $slider.on('init', function(){
      var trackHeight = $slider.find('.slick-track').outerHeight();
      $slider.find('.slick-slide').css('height', trackHeight);
    });
    $slider.slick({
      arrows: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: sliderArrowPrev,
      nextArrow: sliderArrowNext,
      responsive: [
        {
          breakpoint: app.breakpoints.mdMax,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: app.breakpoints.xsMax,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}

/*
Topics in Education Center Hero
*/
$('#topics-slider').slick({
  arrows: true,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: sliderArrowPrev,
  nextArrow: sliderArrowNext,
  fade: true,
  speed: 0, // do animations in css
  autoplay: true,
  autoplaySpeed: 5000
});

/*
Feature Carousel
*/
$('.feature-carousel .items').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  adaptiveHeight: true,
  prevArrow: window.sliderArrowPrev,
  nextArrow: window.sliderArrowNext,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        fade: false
      }
    }
  ]
});